/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { FeatureFlag } from '../../../ts/feature-flags';

export const INTEGRATIONS_FEATURE_FLAGS = {
  INTEGRATIONS: FeatureFlag.INTEGRATIONS,
  PHONE: FeatureFlag.PHONE,
  PHONE_AMAZON_CONNECT: FeatureFlag.PHONE_AMAZON_CONNECT,
  PHONE_GATEWAY: 'phone-gateway-enabled',
  SALESFORCE: FeatureFlag.WEB_EXPERIENCE_SALESFORCE,
  SMS_WITH_TWILIO: FeatureFlag.TWILIO_TEXT_INTEGRATION,
  SOE_ENABLED: FeatureFlag.PHONE_SOE_SUPPORT,
  WEB_CHAT: [FeatureFlag.WEB_EXPERIENCE],
  WHATSAPP: FeatureFlag.WHATSAPP_INTEGRATION,
  ZENDESK: FeatureFlag.WEB_EXPERIENCE_ZENDESKWEB
};
